/* MD header behavior (architecture.md 5.2). Loaded by sections/header.liquid after Dawn's global.js; global.js stays stock.
   1. CR-N-3: under prefers-reduced-motion: reduce, MenuDrawer.closeAnimation closes at once. In every mode a timer
      fallback removes details[open] if the requestAnimationFrame wait has not finished after 450 ms.
   2. FQC-6-3: the mobile header drawer behaves as a dialog. On open, focus moves to the first focusable item in the
      drawer; Tab and Shift+Tab stay inside the trigger and the drawer's visible items; Escape (keydown) closes it,
      sets aria-expanded="false" and returns focus to the trigger. Open submenus keep Dawn's own trap and Escape. */
(() => {
  const MenuDrawer = customElements.get('menu-drawer');
  if (!MenuDrawer || MenuDrawer.prototype.mdPatched) return;
  MenuDrawer.prototype.mdPatched = true;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const dawnClose = MenuDrawer.prototype.closeAnimation;
  const refocusParent = (detailsElement) => {
    const parent = detailsElement.closest('details[open]');
    if (parent && typeof trapFocus === 'function') trapFocus(parent, detailsElement.querySelector('summary'));
  };
  MenuDrawer.prototype.closeAnimation = function (detailsElement) {
    if (reduce.matches) {
      detailsElement.removeAttribute('open');
      refocusParent(detailsElement);
      return;
    }
    dawnClose.call(this, detailsElement);
    setTimeout(() => {
      if (detailsElement.hasAttribute('open') && !detailsElement.classList.contains('menu-opening')) {
        detailsElement.removeAttribute('open');
        refocusParent(detailsElement);
      }
    }, 450);
  };

  const FOCUSABLE = 'a[href], button:not([disabled]), summary, input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const shown = (el) => (el.checkVisibility ? el.checkVisibility({ visibilityProperty: true }) : el.getClientRects().length > 0);

  const setup = (drawer) => {
    if (drawer.mdDialog) return;
    const details = drawer.querySelector('details');
    const summary = details && details.querySelector(':scope > summary');
    const panel = drawer.querySelector('#menu-drawer');
    if (!details || !summary || !panel) return;
    drawer.mdDialog = true;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', summary.getAttribute('aria-label') || 'Menu');

    const firstItem = () => Array.from(panel.querySelectorAll(FOCUSABLE)).find(shown);
    const stops = () => [summary].concat(Array.from(panel.querySelectorAll(FOCUSABLE)).filter((el) => shown(el) && !el.closest('details:not([open]) > :not(summary)')));
    const submenuOpen = () => !!panel.querySelector('details[open]');

    const focusFirst = (tries = 0) => {
      if (!details.open) return;
      const first = firstItem();
      if (first) first.focus();
      else if (tries < 20) setTimeout(() => focusFirst(tries + 1), 25);
    };
    details.addEventListener('toggle', () => {
      if (details.open) setTimeout(focusFirst, 0);
    });

    const close = () => {
      if (typeof drawer.closeMenuDrawer === 'function') {
        drawer.closeMenuDrawer(new KeyboardEvent('keyup', { key: 'Escape', code: 'Escape' }), summary);
      } else {
        details.removeAttribute('open');
      }
      summary.setAttribute('aria-expanded', 'false');
      summary.focus();
    };

    document.addEventListener('keydown', (event) => {
      if (!details.open || !details.classList.contains('menu-opening')) return;
      if (event.key === 'Escape') {
        if (submenuOpen()) return; /* Dawn closes the open submenu on keyup and refocuses its summary */
        event.preventDefault();
        close();
        return;
      }
      if (event.key !== 'Tab' || submenuOpen()) return;
      const list = stops();
      if (!list.length) return;
      const i = list.indexOf(document.activeElement);
      if (event.shiftKey && i <= 0) {
        event.preventDefault();
        list[list.length - 1].focus();
      } else if (!event.shiftKey && (i === -1 || i === list.length - 1)) {
        event.preventDefault();
        list[0].focus();
      }
    });
  };

  const init = () => document.querySelectorAll('header-drawer').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
